module.exports = __webpack_public_path__ + "f6a837b76f3bcf6f3ad10ea3e20bf9a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 601
// module chunks = 0